/* RESPONSIBLE TEAM: team-data-foundations */
import ApplicationAdapter from 'embercom/adapters/application';

export default class InstallationEvents extends ApplicationAdapter {
  urlForQueryRecord(query) {
    let { appPackageId } = query;
    return `ember/developer_hub/app_packages/${appPackageId}/reports/installation_events`;
  }
}
